import * as Yup from 'yup';
import { messages } from 'app/config/constants';
import { SUBJECT_TYPE_ENUM } from 'app/shared/enumeration/enums';
import { defaultAddressValidation } from 'app/shared/address-input/model/address.schema';

export const addedPersonValidationSchema = Yup.object({
  subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  person: Yup.object()
    .nullable()
    .notRequired()
    .when('subjectType', (subjectType, schema) => {
    if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .min(11, messages.OIB_MIN_MAX_LENGTH)
          .max(11, messages.OIB_MIN_MAX_LENGTH),
        firstName: Yup.string().required(messages.MANDATORY_FIELD),
        lastName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        firstName: Yup.string().notRequired(),
        lastName: Yup.string().notRequired(),
      }).notRequired();
    }
  }),
  legalEntity: Yup.object().when('subjectType', (subjectType, schema) => {
    if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .min(11, messages.OIB_MIN_MAX_LENGTH)
          .max(11, messages.OIB_MIN_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        companyName: Yup.string().notRequired(),
      }).notRequired();
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.OBRT) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        mb: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .max(11, messages.MB_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      }).notRequired();
    }
  }),
  address: defaultAddressValidation,
  email: Yup.string().email('Neispravan format').notRequired(),
});
